// Hodnocení obchodu (issue #38, screens/14-hodnoceni.md + m14-hodnoceni.md,
// mockupy design/„Hodnocení obchodu(.mobil).dc.html").
//
// POZOR — spec počítala s Heureka widgetem, který se nahrazuje. Na dev instanci
// je `/hodnoceni-obchodu/` NATIVNÍ výpis hodnocení Shoptetu s reálnými daty:
//   #ratingWrapper.rate-wrapper
//     .rate-average (průměr) + .stars-label (počet do průměru)
//     .votes > .rate-list[data-score] > .rate-count (histogram)
//     .add-comment.rate-form-trigger (nativní tlačítko, data-unveil) + #rate-form
//   #ratingsList > .vote-wrap × N (hvězdy, datum, text; část importovaná z Heureky)
//   .listingControls > nav.pagination + .itemsTotal
// Průměr, histogram, počty i recenze proto BEREME ODTUD — nic se nedoplňuje
// ani nevymýšlí. Karty recenzí zůstávají nativní (restyl + doplněná hlavička).
//
// ODCHYLKY OD SPECKY (ověřeno na dev instanci 2026-07-29):
//   • Jméno autora: dev ho nevydává, ostrá od 10/2026 ano (`.vote-name`
//     `data-testid="textRatingAuthor"`, 7. 10. 2026 u 15 z 20 karet první strany:
//     hodnocení z webu). Karta ukazuje jméno, kde je, jinak neutrální „Zákazník"
//     (rozhodnutí Tomáše 7. 10. 2026, do té doby stál „Zákazník" nad jménem);
//     zelenou pilulku „Ověřeno Heurekou" dostane jen ta, jejíž text nese
//     `.heureka-rating-group` (tj. je z Heureky).
//   • Shoptet neumí filtrovat výpis podle počtu hvězd (`?score=5` ignoruje) →
//     filtr pracuje s hodnoceními NA AKTUÁLNÍ STRANĚ a říká to v popisku;
//     počty v pilulkách jsou celkové z histogramu.
//   • „Přidat hodnocení" nevede na Heureku — je to nativní formulář Shoptetu
//     (`#rate-form`), takže se jen přesouvá a restyluje.
//   • Nativní výpis nemá loadMore (jen stránkování), proto i na mobilu jede
//     pager se šipkami a „Strana X z Y" (vzor z m04), ne „Načíst další".
//
// JAK RECENZE OVĚŘUJEME (zadání Tomáše 7. 10. 2026, mock A na plátně
// H8uCHzSqpDc7pGLKVKyswp, řada „Hodnocení obchodu · Jak recenze ověřujeme",
// docs/design/2026-10-07-hodnoceni-overovani/): informace podle § 5a odst. 5
// ZOS stojí pod přehledem jako legenda štítků, které zákazník vidí u recenzí
// (karta na detailu, patička, tahle stránka). Sekce nese kotvu z manifestu
// (`reviews.verifyAnchor`, reviewsVerify.js), na kterou vedou odkazy z detailu,
// patičky a e-mailu; do té doby to byla samostatná stránka /jak-recenze-overujeme/.
//
// SOUHRN NAHOŘE (návrh S schválený Tomášem 7. 10. 2026, táž řada plátna):
// stránka „Všechna hodnocení" ukazovala „4,9 z 3 816, průměr ze všech hodnocení
// obchodu", zatímco patička a zbytek webu 4,7 z 21 277 napříč platformami.
// Nahoře je proto TÝŽ souhrn a tytéž řádky platforem jako v patičce (reviews.js:
// záloha z manifestu, pak `/reviews/summary`), výpis pod ním má vlastní nadpis
// a větu, co v něm je (hodnocení z webu a převzatá z Heureky), s nativním
// průměrem a počtem. Histogram odpadl (stejná čísla nesou pilulky filtru),
// nativní „Přidat hodnocení" stojí u nadpisu výpisu, pás hodnocení v patičce
// se na téhle stránce nekreslí (siteFooter.js).

import SHOP from '../../config/shop.js';
import { icon, iconHtml } from './icon.js';
import { pageInfo, pageUrlFactory } from './blogModel.js';
import { el, link, textOf, iconBox, markReady } from './infoPage.js';
import { bodyClass } from './pages.js';
import { loadReviews, manifestRows, platformRow, summaryLines } from './reviews.js';
import { decimal, summarize } from './reviewsModel.js';
import { verifyAnchor } from './reviewsVerify.js';
import L from '../locale/cs/ratingsPage.js';
import RH from '../locale/cs/reviewHighlights.js';

const LABEL_EYEBROW = L.eyebrow;
const LABEL_PEREX = L.perex;
const LABEL_FILTER = L.filter;
const LABEL_ALL = L.all;
const LABEL_FILTER_NOTE = L.filterNote;
const LABEL_EMPTY = L.empty;
const LABEL_EMPTY_CTA = L.emptyCta;
const LABEL_CUSTOMER = L.customer;
const LABEL_VERIFIED = L.verified;
const LABEL_PAGE = L.page;
const MONTH_DOT = L.monthDot;

function isRatings() {
  return document.body.classList.contains(bodyClass('ratings')) && !!document.getElementById('ratingsList');
}

function num(text) {
  const n = parseInt(String(text).replace(/[^\d]/g, ''), 10);
  return isFinite(n) ? n : null;
}

function formatCount(value) {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
}

// „30.5.2026" → „30. 5. 2026"
function formatDate(text) {
  const m = /^(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})$/.exec((text || '').trim());
  return m ? m[1] + MONTH_DOT + m[2] + MONTH_DOT + m[3] : (text || '').trim();
}

// ---------------------------------------------------------------------------
// Čtení nativních dat
// ---------------------------------------------------------------------------
function readSummary() {
  const avgNode = document.querySelector('.rate-average');
  const label = document.querySelector('.rate-star-wrap .stars-label');
  const avgText = textOf(avgNode);
  const avg = parseFloat(avgText.replace(',', '.'));
  return {
    text: avgText,
    value: isFinite(avg) ? avg : null,
    count: num(textOf(label)),
  };
}

function readDistribution() {
  const rows = document.querySelectorAll('.votes .rate-list');
  const out = [];
  rows.forEach(function (row) {
    const score = parseInt(row.getAttribute('data-score'), 10);
    const count = num(textOf(row.querySelector('.rate-count')));
    if (!isFinite(score) || count == null) return;
    out.push({ score: score, count: count });
  });
  return out.sort(function (a, b) {
    return b.score - a.score;
  });
}

function totalRatings() {
  return num(textOf(document.querySelector('.listingControls .itemsTotal strong')));
}

// Skóre karty: nativní `.star-on` (+ půlhvězda) v hlavičce hodnocení
function cardScore(card) {
  const stars = card.querySelector('.vote-rating .stars, .stars');
  if (!stars) return null;
  const full = stars.querySelectorAll('.star-on').length;
  const half = stars.querySelectorAll('.star-half').length;
  const value = full + (half ? 0.5 : 0);
  return value ? Math.round(value) : null;
}

// ---------------------------------------------------------------------------
// Stavba — hlavička a přehled
// ---------------------------------------------------------------------------
function stars(percent, size) {
  const wrap = el('span', 'bs-stars' + (size ? ' bs-stars--' + size : ''));
  wrap.setAttribute('aria-hidden', 'true');
  wrap.appendChild(document.createTextNode('★★★★★'));
  const fill = el('span', 'bs-stars__fill', '★★★★★');
  fill.style.setProperty('--bs-stars-pct', percent);
  wrap.appendChild(fill);
  return wrap;
}

// Souhrn napříč platformami (návrh S): týž součet a tytéž řádky jako patička,
// řádek webu shopu vede na výpis pod souhrnem. `rows` = `manifestRows()`, po
// dorazu API řádky z `loadReviews()`. Bez platforem null (souhrn se nekreslí,
// výpis má svá čísla v hlavičce).
const LIST_ID = 'vypis-hodnoceni';

function buildOverview(rows) {
  const s = summarize(rows);
  if (!s) return null;
  const lines = summaryLines(s);
  const overview = el('section', 'bs-rate__overview');
  overview.setAttribute('data-bs-source', rows.some((r) => r.source === 'api') ? 'api' : 'manifest');

  const panel = el('div', 'bs-rate__score');
  panel.appendChild(iconBox('rosette', 'bs-rate__score-mark'));
  const line = el('div', 'bs-rate__score-line');
  line.appendChild(el('span', 'bs-rate__score-num', decimal(s.stars)));
  line.appendChild(el('span', 'bs-rate__score-max', '/ 5'));
  panel.appendChild(line);
  panel.appendChild(stars(Math.round((s.stars / 5) * 100) + '%', 'lg'));
  panel.appendChild(el('div', 'bs-rate__score-count', lines.count));
  panel.appendChild(el('div', 'bs-rate__score-note', lines.source));
  if (lines.converted) panel.appendChild(el('div', 'bs-rate__score-conv', lines.converted));
  overview.appendChild(panel);

  const card = el('div', 'bs-rate__plats');
  card.appendChild(el('div', 'bs-rate__plats-title', L.platformsTitle));
  rows.forEach(function (p) {
    card.appendChild(platformRow(p, rows, '#' + LIST_ID));
  });
  overview.appendChild(card);
  return overview;
}

// Hlavička výpisu: co ve výpisu je, nativní průměr a počet a přesunuté nativní
// „Přidat hodnocení". Shoptet nabízí DVA různé celkové počty: `.stars-label`
// (kolik hodnocení má hvězdičkové skóre, základ průměru) a `.listingControls
// .itemsTotal` (kolik záznamů je ve výpisu; rozdíl jsou slovní hodnocení bez
// hvězd). Počet bere z VÝPISU, ze kterého jedou i pilulky filtru a čítač strany
// (#34: jinak by na jedné obrazovce stála dvě různá čísla).
function buildListHead(summary, total, trigger) {
  const head = el('section', 'bs-rate__head');
  head.id = LIST_ID;
  head.setAttribute('aria-labelledby', LIST_ID + '-title');
  const text = el('div', 'bs-rate__head-text');
  const title = el('h2', 'bs-rate__head-title', L.listTitle);
  title.id = LIST_ID + '-title';
  text.appendChild(title);
  const shown = total != null ? total : summary.count;
  if (shown != null) {
    const avg = summary.value != null ? summary.text : null;
    text.appendChild(el('p', 'bs-rate__head-sub', L.listSub(formatCount(shown), shown, avg)));
  }
  head.appendChild(text);
  if (trigger) {
    trigger.classList.add('bs-rate__add');
    head.appendChild(trigger); // nativní tlačítko (data-unveil) se PŘESOUVÁ
  }
  return head;
}

// ---------------------------------------------------------------------------
// Stavba — filtr
// ---------------------------------------------------------------------------
function buildFilter(dist, total, onPick) {
  const wrap = el('div', 'bs-rate__filter');
  const row = el('div', 'bs-rate__pills');
  const label = el('span', 'bs-rate__filter-label');
  label.appendChild(icon('filter'));
  label.appendChild(el('span', null, LABEL_FILTER));
  row.appendChild(label);

  const pills = [];
  const make = function (score, text, count) {
    const pill = el('button', 'bs-rate__pill');
    pill.type = 'button';
    pill.appendChild(el('span', 'bs-rate__pill-label', text));
    if (count != null) pill.appendChild(el('span', 'bs-rate__pill-count', formatCount(count)));
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p === pill);
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      onPick(score);
    });
    pill.setAttribute('aria-pressed', score === 0 ? 'true' : 'false');
    if (score === 0) pill.classList.add('is-active');
    pills.push(pill);
    row.appendChild(pill);
  };

  make(0, LABEL_ALL, total);
  dist.forEach(function (item) {
    make(item.score, item.score + '★', item.count);
  });

  wrap.appendChild(row);
  wrap.appendChild(el('div', 'bs-rate__filter-note', LABEL_FILTER_NOTE));
  return { node: wrap, reset: function () { if (pills[0]) pills[0].click(); } };
}

// ---------------------------------------------------------------------------
// Stavba — karty hodnocení (restyl nativních `.vote-wrap`)
// ---------------------------------------------------------------------------
function enhanceCards(list) {
  const cards = [];
  list.querySelectorAll('.vote-wrap').forEach(function (card) {
    const score = cardScore(card);
    card.classList.add('bs-rate__card');
    if (score) card.setAttribute('data-bs-score', String(score));

    const header = card.querySelector('.vote-header');
    const summary = card.querySelector('.vote-summary');
    const content = card.querySelector('.vote-content');
    const verified = !!(content && content.querySelector('.heureka-rating-group'));

    if (header && !header.querySelector('.bs-rate__avatar')) {
      header.classList.add('bs-rate__card-head');
      header.insertAdjacentElement('afterbegin', iconBox('user', 'bs-rate__avatar'));
    }
    if (summary && !summary.querySelector('.bs-rate__name')) {
      // nativní jméno autora přebírá roli štítku, „Zákazník" jen tam, kde chybí
      const author = summary.querySelector('.vote-name');
      if (author && textOf(author)) author.classList.add('bs-rate__name');
      else summary.insertAdjacentElement('afterbegin', el('div', 'bs-rate__name', LABEL_CUSTOMER));
    }
    if (verified && header && !header.querySelector('.bs-rate__verified')) {
      const pill = el('span', 'bs-rate__verified');
      pill.innerHTML = iconHtml('check');
      pill.appendChild(el('span', null, LABEL_VERIFIED));
      header.appendChild(pill);
    }
    const time = card.querySelector('.vote-time');
    if (time && !time.hasAttribute('data-bs-date')) {
      time.setAttribute('data-bs-date', '1');
      time.textContent = formatDate(textOf(time));
    }
    if (content) content.classList.add('bs-rate__text');
    cards.push({ node: card, score: score });
  });
  return cards;
}

// ---------------------------------------------------------------------------
// Stavba: Jak recenze ověřujeme (§ 5a odst. 5 ZOS). Štítky jsou TYTÉŽ texty
// jako na kartě recenzí detailu (locale reviewHighlights), věty schválené
// Tomášem 6. a 7. 10. 2026 je citují; změna štítku tak změní i větu.
// ---------------------------------------------------------------------------
function buildVerify(id) {
  const sec = el('section', 'bs-rate__verify');
  sec.id = id;
  sec.setAttribute('aria-labelledby', id + '-title');

  const head = el('div', 'bs-rate__verify-head');
  head.appendChild(iconBox('shield', 'bs-rate__verify-mark'));
  const title = el('h2', 'bs-rate__verify-title', L.verifyTitle);
  title.id = id + '-title';
  head.appendChild(title);
  sec.appendChild(head);

  const items = [
    { label: RH.sourceHeureka, text: L.verifyHeureka, heureka: true },
    { label: RH.sourceWeb(SHOP.shop.name), text: L.verifyWeb },
    { label: RH.buyer, text: L.verifyBuyer },
    { label: RH.shopLabel, text: L.verifyShop },
  ];
  const list = el('div', 'bs-rate__verify-list');
  items.forEach(function (item) {
    const box = el('div', 'bs-rate__verify-item');
    const label = el('span', 'bs-rate__verify-label' + (item.heureka ? ' bs-rate__verify-label--heureka' : ''));
    if (item.heureka) label.appendChild(icon('shield'));
    label.appendChild(el('span', null, item.label));
    box.appendChild(label);
    box.appendChild(el('p', 'bs-rate__verify-text', item.text(item.label)));
    list.appendChild(box);
  });
  sec.appendChild(list);
  return sec;
}

// Příchod odkazem s kotvou sekce (karta na detailu, patička, e-mail, 301 ze
// staré stránky). Sekci staví JS, nativní skok na kotvu při načtení ji tedy
// najít nemusí → skok po stavbě a ještě po `load` (písmo a obrázky nad sekcí),
// dokud návštěvník sám nescrolloval (vzor `arrivalAnchor` v productDetail.js).
function arriveAt(target) {
  let hash = '';
  try {
    hash = decodeURIComponent(window.location.hash.slice(1));
  } catch (e) {
    return; // nevalidní %-sekvence v kotvě
  }
  if (hash !== target.id) return;
  let moved = false;
  const stop = function () {
    moved = true;
  };
  ['wheel', 'touchmove', 'keydown'].forEach(function (type) {
    window.addEventListener(type, stop, { passive: true, once: true });
  });
  const jump = function () {
    if (!moved && target.isConnected) target.scrollIntoView({ block: 'start' });
  };
  jump();
  if (document.readyState !== 'complete') window.addEventListener('load', jump, { once: true });
}

// ---------------------------------------------------------------------------
// Stavba — stránkování (nativní `nav.pagination` renderuje jen aktuální/další/poslední)
// ---------------------------------------------------------------------------
function pageWindow(page, pages) {
  const set = {};
  const add = function (n) {
    if (n >= 1 && n <= pages) set[n] = true;
  };
  add(1);
  add(pages);
  add(page - 1);
  add(page);
  add(page + 1);
  if (page === 1) add(3);
  if (page === pages) add(pages - 2);
  return Object.keys(set)
    .map(Number)
    .sort(function (a, b) {
      return a - b;
    });
}

function pagerArrow(dir, href) {
  const node = href ? link(href, 'bs-rate__parrow') : el('span', 'bs-rate__parrow is-off');
  node.innerHTML = iconHtml(dir === 'prev' ? 'arrow-left' : 'arrow-right');
  if (href) node.setAttribute('aria-label', dir === 'prev' ? L.prevPage : L.nextPage);
  return node;
}

function buildPager(info) {
  if (!info.pages || info.pages < 2) return null;
  const url = pageUrlFactory();
  const nav = el('nav', 'bs-rate__pager');
  nav.setAttribute('aria-label', L.pagerAria);
  nav.appendChild(pagerArrow('prev', info.page > 1 ? url(info.page - 1) : null));

  const list = el('div', 'bs-rate__pages');
  const nums = pageWindow(info.page, info.pages);
  let last = 0;
  nums.forEach(function (n) {
    if (n - last > 1) list.appendChild(el('span', 'bs-rate__pgap', '…'));
    if (n === info.page) {
      const cur = el('span', 'bs-rate__pnum is-current', String(n));
      cur.setAttribute('aria-current', 'page');
      list.appendChild(cur);
    } else {
      list.appendChild(link(url(n), 'bs-rate__pnum', String(n)));
    }
    last = n;
  });
  nav.appendChild(list);
  nav.appendChild(el('span', 'bs-rate__plabel', LABEL_PAGE + info.page + ' z ' + info.pages));
  nav.appendChild(pagerArrow('next', info.page < info.pages ? url(info.page + 1) : null));
  return nav;
}

// ---------------------------------------------------------------------------
// Nativní formulář hodnocení: tlačítko odkrývá `#rate-form` přidáním `.visible`
// (Shoptet `data-unveil`). Když default JS neběží, dorovnáme to sami.
// ---------------------------------------------------------------------------
function guardUnveil(trigger, form) {
  if (!trigger || !form) return;
  const button = trigger.matches('button') ? trigger : trigger.querySelector('button');
  if (!button) return;
  // Nativní handler `.visible` PŘEPÍNÁ — stav se proto čte PŘED ním (capture)
  // a dorovnává se jen, když se po kliku nezměnil (default JS neběží). Dřív
  // pojistka po druhém kliku formulář znovu otevřela (code review B5-07).
  button.addEventListener(
    'click',
    function () {
      const wasOpen = form.classList.contains('visible');
      window.setTimeout(function () {
        if (form.classList.contains('visible') === wasOpen) form.classList.toggle('visible', !wasOpen);
        button.setAttribute('aria-expanded', form.classList.contains('visible') ? 'true' : 'false');
      }, 250);
    },
    true
  );
}

// ---------------------------------------------------------------------------
export function initRatingsPage() {
  if (!isRatings()) return;
  const inner = document.querySelector('#content .content-inner') || document.querySelector('.content-inner');
  const list = document.getElementById('ratingsList');
  if (!inner || !list || inner.querySelector('.bs-rate')) return;

  const summary = readSummary();
  const dist = readDistribution();
  const total = totalRatings();
  const info = pageInfo();

  const root = el('div', 'bs-ip bs-rate');

  // hero — nativní H1 se PŘESOUVÁ (zůstává nadpisem stránky)
  const head = el('section', 'bs-ip__hero');
  const text = el('div', 'bs-ip__hero-text');
  text.appendChild(el('span', 'bs-ip__eyebrow', LABEL_EYEBROW));
  const h1 = inner.querySelector('h1');
  if (h1) {
    h1.classList.add('bs-ip__title');
    text.appendChild(h1);
  }
  text.appendChild(el('p', 'bs-ip__perex', LABEL_PEREX));
  head.appendChild(text);
  root.appendChild(head);

  // souhrn napříč platformami hned ze zálohy v manifestu, živá čísla z API ho vymění
  const overview = buildOverview(manifestRows());
  if (overview) {
    root.appendChild(overview);
    loadReviews().then(function (live) {
      if (!live || !overview.isConnected) return;
      const next = buildOverview(live.rows);
      if (next) overview.replaceWith(next);
    });
  }

  // Jak recenze ověřujeme: pod souhrnem
  const anchorId = verifyAnchor();
  const verify = anchorId ? buildVerify(anchorId) : null;
  if (verify) root.appendChild(verify);

  // výpis + filtr
  const cards = enhanceCards(list);
  const counter = el('div', 'bs-rate__counter');
  const empty = el('div', 'bs-rate__empty');
  empty.appendChild(iconBox('star', 'bs-rate__empty-icon'));
  empty.appendChild(el('div', 'bs-rate__empty-title', LABEL_EMPTY));

  const apply = function (score) {
    let shown = 0;
    cards.forEach(function (card) {
      const match = !score || card.score === score;
      card.node.classList.toggle('bs-rate__card--off', !match);
      if (match) shown += 1;
    });
    const totalTxt = total != null ? formatCount(total) : '?';
    if (!score) {
      counter.textContent = L.counterAll(info.page, info.pages, shown, totalTxt);
    } else {
      const bucket = dist.filter(function (d) {
        return d.score === score;
      })[0];
      counter.textContent = L.counterFiltered(score, shown, cards.length, bucket ? formatCount(bucket.count) : null);
    }
    empty.classList.toggle('is-on', shown === 0);
  };

  const filter = buildFilter(dist, total, apply);

  const emptyCta = el('button', 'bs-ip__cta bs-ip__cta--outline bs-rate__empty-cta', LABEL_EMPTY_CTA);
  emptyCta.type = 'button';
  emptyCta.addEventListener('click', filter.reset);
  empty.appendChild(emptyCta);

  // seznam zůstává nativní, jen dostane mřížku a prázdný stav
  list.classList.add('bs-rate__list');
  inner.insertBefore(root, inner.firstChild);
  list.insertAdjacentElement('beforebegin', empty);

  // Filtr a počítadlo jsou SOUROZENCI výpisu, ne děti `root` (DR U6 / J8).
  // `position: sticky` se lepí jen v rámci vlastního rodiče — dokud filtr visel
  // v `root`, končil jeho rozsah pár desítek pixelů pod ním a mobilní lišta
  // odjela hned na prvním scrollu (naměřeno top −166 px místo 122).
  // Vizuální pořadí: root → hlavička výpisu (+ odkrytý formulář) → filtr →
  // počítadlo → prázdný stav → výpis.
  empty.insertAdjacentElement('beforebegin', filter.node);
  filter.node.insertAdjacentElement('afterend', counter);

  // hlavička výpisu s přesunutým nativním „Přidat hodnocení"; formulář se
  // odkrývá hned pod ní, v toku nad filtrem
  const trigger = document.querySelector('.rate-form-trigger');
  const listHead = buildListHead(summary, total, trigger);
  filter.node.insertAdjacentElement('beforebegin', listHead);
  const form = document.getElementById('rate-form');
  if (form) {
    form.classList.add('bs-rate__form');
    listHead.insertAdjacentElement('afterend', form);
    guardUnveil(trigger, form);
  }

  const pager = buildPager(info);
  if (pager) {
    const controls = document.querySelector('.listingControls');
    if (controls) controls.insertAdjacentElement('beforebegin', pager);
    else list.insertAdjacentElement('afterend', pager);
  }

  apply(0);
  markReady();
  document.documentElement.classList.add('bs-rate-ready');
  // až teď stojí celé rozvržení (nativní přehled schovaný, výpis v mřížce)
  if (verify) arriveAt(verify);
}
